module.exports = __webpack_public_path__ + "assets/img/Record_btn.4c398cdb.png";